import NewCategory from './NewCategory';

export default NewCategory;
